module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-1-148e5d01dd1c88554effaa6a27d76043.svg";